import { getMyWorkspaces } from '@/features/onboarding/services/workspaceApi'

export async function resolvePostLoginRoute(): Promise<{ path: string; state?: unknown }> {
  try {
    const workspaces = await getMyWorkspaces()
    if (workspaces.length === 0) return { path: '/onboarding' }
  } catch {
    // fall through to dashboard on error
  }
  return { path: '/dashboard' }
}
